/**
 * Page View Tracker
 * Automatically tracks page views when route changes occur
 */

import Tracking from "./index";

/**
 * Initialize page view tracking on history changes
 * @param {Object} history - Browser history object from react-router
 */
export const initPageViewTracking = (history) => {
  // Track initial page load
  trackCurrentPage();

  // Listen for route changes and track page views
  history.listen((location, action) => {
    // Track page view on route change
    trackCurrentPage(location);
  });
};

/**
 * Track the current page view
 * @param {Object} location - Location object from react-router (optional)
 */
const trackCurrentPage = (location = window.location) => {
  const pagePath = location.pathname + location.search;
  const pageTitle = document.title || "Donation Pickup";

  // Call the tracking service's page view method
  Tracking.trackPageView(pagePath, pageTitle);

  // You can also send specific events to different services if needed
  // For example, send enhanced ecommerce data to GA4 for specific pages
  if (location.pathname === "/donation-pickup/confirmation") {
    // Track pickup confirmation as a conversion event
    Tracking.ga4("Conversion", "pickup_confirmation");
    Tracking.gtm("conversion", {
      event_category: "Conversion",
      event_action: "pickup_confirmation",
      page_path: pagePath,
    });
  }
};

/**
 * Manually track a page view (useful for single-page app state changes)
 * @param {string} pagePath - The path to track
 * @param {string} pageTitle - The page title (optional)
 */
export const trackPageView = (pagePath, pageTitle) => {
  Tracking.trackPageView(pagePath, pageTitle);
};

export default initPageViewTracking;
